import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const projects = [
  {
    id: 1,
    title: 'Smart ECG Monitor',
    category: 'Medical',
    description: 'Real-time cardiac insights. Anywhere. Anytime.'
  },
  {
    id: 2,
    title: 'Automating Systems',
    category: 'Automation',
    description: 'Transforming operations into intelligent, self-optimising systems.'
  },
  {
    id: 3,
    title: 'Vision Systems',
    category: 'Vision',
    description: 'Seeing beyond human vision for flawless quality.'
  },
  {
    id: 4,
    title: 'AI Solutions',
    category: 'AI',
    description: 'Empowering systems with intelligent decision-making.'
  },
  {
    id: 5,
    title: 'IoT Device Platform',
    category: 'IoT',
    description: 'Connecting everything. Analysing instantly.'
  }
];

const categories = ['All', 'Medical', 'Automation', 'AI', 'Vision', 'IoT'];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredProjects = activeCategory === 'All'
    ? projects
    : projects.filter(project => project.category === activeCategory);

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Medical': return '#24A148'; // green
      case 'Automation': return '#FF7F50'; // coral orange
      case 'AI': return '#003366'; // deep blue
      case 'Vision': return '#6C63FF'; // purple
      case 'IoT': return '#00B4D8'; // cyan
      default: return '#003366'; // fallback deep blue
    }
  };

  return (
    <section
      id="portfolio"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          maxWidth: '1600px',
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <div
            style={{
              display: 'inline-block',
              background: '#007bff',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '24px',
              padding: '12px 35px',
              borderRadius: '25px',
              textTransform: 'uppercase',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            }}
          >
            Portfolio
          </div>
          <h2
            style={{
              color: 'blue',
              fontSize: '22px',
              marginTop: '20px',
              fontWeight: 'bold',
            }}
          >
            Check our Portfolio
          </h2>
          <p
            style={{
              color: 'black',
              fontSize: '22px',
              marginTop: '10px',
            }}
          >
            Explore our latest projects and innovations driving intelligent transformation
          </p>
        </motion.div>

        {/* Category Buttons */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '15px',
            marginBottom: '40px',
          }}
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              style={{
                padding: '10px 25px',
                borderRadius: '25px',
                border: 'none',
                fontWeight: 'bold',
                fontSize: '20px',
                cursor: 'pointer',
                background: activeCategory === category ? getCategoryColor(category) : 'white',
                color: activeCategory === category ? 'white' : 'black',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                transition: 'background 0.3s',
              }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Project Cards */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '30px',
          }}
        >
          <AnimatePresence>
            {filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                style={{
                  background: getCategoryColor(project.category),
                  borderRadius: '20px',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                  padding: '30px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  color: 'white',
                  minHeight: '200px',
                }}
              >
                <h3
                  style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    marginBottom: '10px',
                  }}
                >
                  {project.title}
                </h3>
                <p
                  style={{
                    fontSize: '18px',
                    margin: 0,
                  }}
                >
                  {project.description}
                </p>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
